import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "src/app/base/services/base.service";
import { Observable } from "rxjs";
import { Participantes } from "../models/participantes.model";

@Injectable()
export class ParticipantesService extends BaseService<Participantes> {

  constructor(public http: HttpClient) {
    super(http);
  }
  public getListCombos(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list', { headers: this.headers });
  }
  public sendMail($id: number): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/sendmail/' + $id, { headers: this.headers });
  }
  public getPathModule(): string {
    return '/reuniao/participantes';
  }
}